import * as React from "react";
import { useState, useEffect } from "react";
import { get } from "../../../utils/fetch";
import { Workflow } from "../types";
import { RootState, Page } from "../../types";
import { Organization } from "../../organizations/types";
import { useSelector, useDispatch } from "react-redux";
import { subscribeChannels, unsubscribeChannel } from "../../pubnub/actions";

type Props = {
  setLoading: (isLoading: boolean) => void;
  selectedWorkflow?: Workflow | null;
  setSelectedWorkflow: (workflow: Workflow) => void;
};

const DayView: React.FunctionComponent<Props> = ({
  setLoading,
  selectedWorkflow,
  setSelectedWorkflow
}: Props) => {
  const [waitingRooms, setWaitingRooms] = useState<Page<Workflow> | null>(null);
  const [showSelections, setShowSelections] = useState<boolean>(false);
  const currentOrganization: Organization | null = useSelector(
    (state: RootState) => state.orgs.currentOrganization
  );

  const dispatch = useDispatch();

  const getWaitingRooms = async () => {
    setLoading(true);
    const url = `/api/organization/${currentOrganization?.id}/workflows/`;
    const resp = await get<Page<Workflow>>(url);
    // add filtering for RelatedObjectType.Appointments

    setWaitingRooms(resp.data);
    if (resp.data?.results.length == 1) {
      setSelectedWorkflow(resp.data.results[0]);
    } else {
      setLoading(false);
      setShowSelections(true);
    }
  };

  useEffect(() => {
    getWaitingRooms();
  }, []);

  useEffect(() => {
    if (selectedWorkflow) {
      dispatch(subscribeChannels([selectedWorkflow.id]));
    }
    const prevSelectedWorkflow = selectedWorkflow;
    return () => {
      if (prevSelectedWorkflow) {
        dispatch(unsubscribeChannel(prevSelectedWorkflow.id));
      }
    };
  }, [selectedWorkflow]);

  const selectRoom = (r: Workflow) => {
    setSelectedWorkflow(r);
    setShowSelections(false);
  };

  return (
    <>
      <button
        className={`light-border flex-center ${showSelections && "active"}`}
        onClick={() => setShowSelections(!showSelections)}
      >
        <div className="flex-1 ellipsis">{selectedWorkflow?.name}</div>
        <i className="fas fa-caret-down ml-5"></i>
      </button>

      {showSelections && (
        <div className="select-overlay-container">
          <div className="selections">
            <div className="bold mb-20">Which waiting room would you like to view?</div>
            {waitingRooms &&
              waitingRooms.results.map(r => (
                <button
                  className={`mb-20 ${selectedWorkflow &&
                    selectedWorkflow.id === r.id &&
                    "selected"}`}
                  key={r.id}
                  onClick={() => selectRoom(r)}
                >
                  {r.name}
                </button>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default DayView;
